<template>
  <div class="bg-white container position-fixed-top border col-lg-4 rounded shadow p-lg-4">
    <h4>Add User</h4>
    <b-col class="m-auto">
    <b-form @submit="onSubmit">
      <b-form-group  label="Username:" label-for="input-a">
        <b-form-input
          id="input-a"
          v-model="form.username"
          type="text"
          required
          placeholder="Enter Username"
        ></b-form-input>
      </b-form-group>
        <b-form-group  label="Performance ID:" label-for="input-d">
        <b-form-input
          id="input-d"
          v-model="form.performance_id"
          type="text"
          required
          placeholder="Enter Performance ID"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="New Password:" label-for="input-b">
        <b-form-input
          id="input-b"
          v-model="form.password1"
          type="password"
          required
          placeholder="Enter Password"
        ></b-form-input>
      </b-form-group>
        <div class="alert-danger" v-if="!passwordRule">Password to weak</div>
      <b-form-group label="Repeat Password:" label-for="input-c">
        <b-form-input
          id="input-c"
          v-model="form.password2"
          type="password"
          required
          placeholder="Repeat Password"
        ></b-form-input>
      </b-form-group>
      <div class="alert-danger" v-if="!passwordMatch">Passwords do not match</div>
      <b-button type="submit" variant="primary">Add User</b-button>
      <b-button v-on:click="cancel" variant="primary" class="ml-2">Close</b-button>
    </b-form>
    <b-alert class="m-2"
      :show="dismissCountDown"
      dismissible
      fade
      :variant="variant"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{responseMSG}}
    </b-alert>

    <ul >
        <li>The password must meet the following:</li>
        <ul><li> at least 1 lowercase alphabetical character</li>
        <li>at least 1 uppercase alphabetical character</li>
        <li>at least 1 numeric character</li>
        <li>at least one special character</li>
        <li>be eight characters or longer</li>  </ul>
    </ul>
    </b-col>

  </div>
</template>

<script>
/* eslint-disable */ 
  export default {
    name: "addUser",
    data() {
      return {
        form: {
          username: '',
          password1: '',
          password2: '',
          performance_id: ''
        },
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
        responseMSG: ''
      }
    },
    props: {
      authenticated: {}
    }, 
    methods: {
      onSubmit(evt) {
        evt.preventDefault()
        if (!(this.passwordMatch && this.passwordRule)) {
            return
        }
        let currentObj = this;
        let params = new URLSearchParams();
        params.append('username', this.form.username);
        params.append('password', this.form.password1)
        params.append('performance_id', this.form.performance_id)
        params.append('task', 'newuser');
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    console.log(response.data) 
                    if (response.data.success) {
                        currentObj.form.username = ''
                        currentObj.form.password1 = ''
                        currentObj.form.password2 = ''
                        currentObj.showAlert("success", "User Added")
                    } else {
                        currentObj.showAlert("danger", "User NOT Added")
                    }
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
      cancel(evt) {
          this.$emit('menuItem', false)
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert(type, msg) {
        this.responseMSG = msg
        this.variant = type
        this.dismissCountDown = this.dismissSecs
      }

    },
    computed: {
        passwordMatch: function() { 
            return this.form.password1 == this.form.password2
        },
        passwordRule: function() { 
            var strongRegex = new RegExp ("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
            return strongRegex.test(this.form.password1)
        }
    }
  }
</script>
<style scoped>
.container {
     margin-top: 70px;


}
</style>